import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { PortalLinkInput, Project } from "../Project";

/**
 * 案件の社内ポータル連携を更新する。
 *
 * **指定のあったフィールドだけを送る**（空欄は無操作＝既存の連携を保持）。コンソールと同じ扱いに
 * 揃えている。連携解除はコンソール側の編集→保存に委ね、アドインからは行わない。
 */
export async function updateProject(projectId: string, link: PortalLinkInput): Promise<Project> {
    const portalUrl = link.portalUrl?.trim();
    const portalProjectUrl = link.portalProjectUrl?.trim();
    const res = await fetchWithAuth(`/projects/${encodeURIComponent(projectId)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
            ...(portalUrl ? { portalUrl } : {}),
            ...(portalProjectUrl ? { portalProjectUrl } : {}),
        }),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "案件の更新に失敗しました");
    const body = (await res.json()) as { project: Project };
    return body.project;
}
